const menuItems = [
  {
    id: "all",
    title: "Best Projects"
  },
  {
    id: "react",
    title: "React"
  },
  {
    id: "node",
    title: "Node"
  },
  {
    id: "php",
    title: "PHP"
   }
  ,{
    id: "js",
    title: "Vanilla JS"
  }
];

export default menuItems;